// extracted by mini-css-extract-plugin
export default {"div":"MainModule_div__nHq3w"};